<form #dados="ngForm">
  <div
    *ngIf="!showProgress && globalService.loggedUserClass"
    style="width: 100%; max-width: 400px; min-width: 300px; font-size: 12px"
  >
    <div style="display: flex; flex-direction: row; padding-left: 15px; margin-top: 10px; margin-bottom: -5px">
      <div
        class="user-avatar-menu-wrapper"
        [matMenuTriggerFor]="userPhotoMenu"
        #userPhotoMenuTrigger="matMenuTrigger"
        (contextmenu)="openPhotoContextMenu($event, userPhotoMenuTrigger)"
        style="cursor: pointer"
        [matTooltip]="'USERMENU.PHOTO_MENU.CHANGE_PHOTO' | translate"
      >
        <app-user-avatar
          [photoPath]="
            globalService.loggedUserClass?.customerClass?.Photo || globalService.loggedUserClass?.commercialClass?.Photo
              ? (globalService.loggedUserClass?.customerClass?.Photo ||
                  globalService.loggedUserClass?.commercialClass?.Photo | convertImageToUrl)
              : null
          "
          [userName]="
            globalService.loggedUserClass?.customerClass?.firstLastName ||
            globalService.loggedUserClass?.customerClass?.Name ||
            globalService.loggedUserClass?.commercialClass?.Name ||
            globalService.loggedUserClass?.Nome ||
            ''
          "
          size="menu"
          [editable]="true"
        ></app-user-avatar>
      </div>

      <!-- Input oculto para carregar ficheiro da galeria/dispositivo -->
      <input
        #userPhotoFileInput
        type="file"
        accept="image/png,image/jpeg,image/webp,image/jpg"
        (change)="onPhotoFileSelected($event)"
        style="display: none"
      />

      <!-- Menu em contexto para fotografia de perfil -->
      <mat-menu #userPhotoMenu="matMenu" class="sv-photo-context-menu" xPosition="after">
        <button mat-menu-item (click)="onTakePicture()">
          <mat-icon style="color: #1b1464">photo_camera</mat-icon>
          <span>{{ 'USERMENU.PHOTO_MENU.TAKE_PHOTO' | translate }}</span>
        </button>
        <button mat-menu-item (click)="userPhotoFileInput.click()">
          <mat-icon style="color: #1b1464">photo_library</mat-icon>
          <span>{{ 'USERMENU.PHOTO_MENU.UPLOAD_FROM_DEVICE' | translate }}</span>
        </button>
        <button mat-menu-item *ngIf="hasProfilePhoto" (click)="onViewPhoto()">
          <mat-icon style="color: #1b1464">visibility</mat-icon>
          <span>{{ 'USERMENU.PHOTO_MENU.VIEW_PHOTO' | translate }}</span>
        </button>
        <mat-divider *ngIf="hasProfilePhoto"></mat-divider>
        <button mat-menu-item *ngIf="hasProfilePhoto" (click)="onRemovePhoto()" class="menu-item-danger">
          <mat-icon style="color: #dc3545">delete_outline</mat-icon>
          <span style="color: #dc3545">{{ 'USERMENU.PHOTO_MENU.REMOVE_PHOTO' | translate }}</span>
        </button>
      </mat-menu>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap; padding-left: 15px">
        <p>
          <b style="color: #1c1463; font-size: large">{{
            globalService.loggedUserClass?.customerClass?.firstLastName
          }}</b>
          <br />{{ 'USERMENU.NIF' | translate }} {{ globalService.loggedUserClass?.customerClass?.NIF }}
        </p>
      </div>

      <div style="flex: 1 1 auto"></div>

      <div class="usermenu-top-actions">
        <!-- Trocar Perfil -->
        <div class="usermenu-action-btn" (click)="NifautorizationComponent()" style="text-align: center">
          <i style="font-size: 25px" class="fa fa-exchange" aria-hidden="true"></i><br />{{
            'USERMENU.CHANGE_PROFILE' | translate
          }}
        </div>

        <!-- Cruz + Ajuda empilhados verticalmente -->
        <div class="usermenu-close-help-stack">
          <div class="usermenu-close-btn-top" (click)="option.toggle()" matTooltip="Fechar">
            <mat-icon>close</mat-icon>
          </div>
          <div class="usermenu-action-btn usermenu-help-btn" (click)="baseService.helpbutton(12)" matTooltip="Ajuda">
            <img src="assets/icons/info.png" width="16px" height="16px" alt="Ajuda" class="tutorial-icon-red" />
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        display: flex;
        flex-direction: row;
        margin-top: 8px;
        margin-left: 0px;
        margin-right: 0px;
        margin-bottom: 0px;
        width: 100%;
      "
    >
      <div
        style="margin: 0px; padding: 0px; padding-right: 2px; height: 33px; min-width: 15px"
        [style.backgroundColor]="'var(--color-dark-blue)'"
        [style.color]="'white'"
      ></div>

      <div
        style="width: 100%; margin: 0px; padding-left: 10px; height: 33px; text-align: left"
        class="flex-container"
        mat-dialog-title
        [style.backgroundColor]="'var(--color-dark-blue)'"
        [style.color]="'#FFFFFF'"
      >
        <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin: 0px; padding: 0px">
          <mat-button-toggle-group
            class="custom-user-toggle-group"
            appearance="legacy"
            [(ngModel)]="menu"
            [ngModelOptions]="{ standalone: true }"
          >
            <mat-button-toggle value="cliente" (click)="refresh()">
              {{ 'USERMENU.TAB_MY_DATA' | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="gestor" (click)="refresh()">
              {{ 'USERMENU.TAB_MANAGERS' | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <!-- Cruz na barra azul: visível apenas em mobile -->
      <div
        class="close-button usermenu-close-mobile"
        style="cursor: pointer; padding: 4px; padding-right: 6px; height: 33px; width: 30px; text-align: right"
        [style.backgroundColor]="'var(--color-dark-blue)'"
        [style.color]="'#FFFFFF'"
      >
        <mat-icon (click)="option.toggle()">close</mat-icon>
      </div>
    </div>

    <!-- =========================
         TAB CLIENTE
         ========================= -->
    <div *ngIf="menu === 'cliente' && globalService.loggedUserClass?.customerClass">
      <br />
      <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 0px; padding-top: 0px">
        <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('Name')">
            <mat-label>{{ 'USERMENU.FULL_NAME' | translate }}</mat-label>
            <input
              matInput
              name="name"
              autocomplete="off"
              required
              [(ngModel)]="globalService.loggedUserClass.customerClass.Name"
              (change)="save(true)"
            />
          </mat-form-field>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('AddressDetail')">
            <mat-label>{{ 'USERMENU.ADDRESS' | translate }}</mat-label>
            <input
              matInput
              name="AddressDetail"
              autocomplete="off"
              readonly
              required
              [(ngModel)]="globalService.loggedUserClass.customerClass.AddressDetail"
              (change)="save(true)"
              [matTooltip]="
                globalService.loggedUserClass?.customerClass?.AddressDetail +
                ', ' +
                globalService.loggedUserClass?.customerClass?.PostalCode +
                ' ' +
                globalService.loggedUserClass?.customerClass?.Region
              "
            />
            <button
              type="button"
              matSuffix
              mat-icon-button
              style="font-size: small; margin-right: 0px; padding-right: 0px"
              (click)="findshipaddress()"
            >
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div *ngIf="!isCompany" style="flex: 1 1 50%; box-sizing: border-box; max-width: 50%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('Birthdate')">
            <mat-label>{{ 'USERMENU.BIRTHDATE' | translate }}</mat-label>
            <input
              matInput
              [matDatepicker]="pickerBirthdate"
              name="Birthdate"
              autocomplete="off"
              [ngModelOptions]="{ standalone: true }"
              (focus)="openBirthdate()"
              [(ngModel)]="globalService.loggedUserClass.customerClass.Birthdate"
              [max]="MaiorIdadeHoje"
              required
              (dateChange)="save(true)"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerBirthdate"></mat-datepicker-toggle>
            <mat-datepicker #pickerBirthdate></mat-datepicker>
          </mat-form-field>
        </div>

        <div *ngIf="!isCompany" style="flex: 1 1 50%; box-sizing: border-box; max-width: 50%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('idSexTypes')">
            <mat-label>{{ 'USERMENU.GENDER' | translate }}</mat-label>
            <mat-select
              name="idSexTypes"
              required
              [(ngModel)]="globalService.loggedUserClass.customerClass.idSexTypes"
              (selectionChange)="save(true)"
            >
              <mat-option [value]="null"></mat-option>
              <mat-option *ngFor="let sex of filteredSexTypes; trackBy: trackById" [value]="sex.idSexTypes">
                {{ sex.Description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="!isCompany" style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div style="flex: 1 1 50%; box-sizing: border-box; max-width: 50%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('Drivinglicense')">
            <mat-label>{{ 'USERMENU.DRIVING_LICENSE' | translate }}</mat-label>
            <input
              matInput
              name="Drivinglicense"
              autocomplete="off"
              [ngModelOptions]="{ standalone: true }"
              (dblclick)="drivecategory()"
              (touchstart)="onTouchStart()"
              [(ngModel)]="globalService.loggedUserClass.customerClass.Drivinglicense"
              [matTooltip]="'USERMENU.TOOLTIP_DL_POINT5' | translate"
              (ngModelChange)="
                globalService.loggedUserClass?.customerClass &&
                  (globalService.loggedUserClass.customerClass.Drivinglicense = $event?.toUpperCase?.() ?? $event)
              "
              (change)="save(true)"
            />
          </mat-form-field>
        </div>

        <div style="flex: 1 1 50%; box-sizing: border-box; max-width: 50%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('DrivinglicenseDate')">
            <mat-label>{{ 'USERMENU.DRIVING_LICENSE_FIRST_DATE' | translate }}</mat-label>
            <input
              matInput
              [matDatepicker]="pickerDrivinglicenseDate"
              name="DrivinglicenseDate"
              [max]="MaiorIdadeHoje"
              [ngModelOptions]="{ standalone: true }"
              (focus)="openDrivinglicenseDate()"
              autocomplete="off"
              [matTooltip]="'USERMENU.TOOLTIP_DL_BACK_B' | translate"
              [(ngModel)]="globalService.loggedUserClass.customerClass.DrivinglicenseDate"
              (dateChange)="save(true)"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerDrivinglicenseDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerDrivinglicenseDate></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div *ngIf="!isCompany" style="flex: 1 1 50%; box-sizing: border-box; max-width: 50%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('idMaritalStatus')">
            <mat-label>{{ 'USERMENU.MARITAL_STATUS' | translate }}</mat-label>
            <mat-select
              name="idMaritalStatus"
              required
              [(ngModel)]="globalService.loggedUserClass.customerClass.idMaritalStatus"
              (selectionChange)="save(true)"
            >
              <mat-option [value]="null"></mat-option>
              <mat-option
                *ngFor="let EstadoCivil of globalService.maritalStatusClass; trackBy: trackById"
                [value]="EstadoCivil.idMaritalStatus"
              >
                {{ EstadoCivil.Description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div style="flex: 1 1 50%; box-sizing: border-box; max-width: 50%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('Contact')">
            <mat-label>{{ 'USERMENU.CONTACT' | translate }}</mat-label>
            <input
              matInput
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="9"
              name="phone"
              autocomplete="off"
              [(ngModel)]="globalService.loggedUserClass.customerClass.Contact"
              (keypress)="$event.charCode >= 48 && $event.charCode <= 57 ? true : $event.preventDefault()"
              (paste)="$event.preventDefault()"
              (change)="save(true)"
            />
          </mat-form-field>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div *ngIf="!isCompany" style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('Profession')">
            <mat-label>{{ 'USERMENU.PROFESSION' | translate }}</mat-label>
            <input
              type="text"
              matInput
              (ngModelChange)="filter($event)"
              name="Profession"
              [ngModelOptions]="{ standalone: true }"
              autocomplete="off"
              [(ngModel)]="globalService.loggedUserClass.customerClass.Profession"
              (change)="save(true)"
              [matAutocomplete]="autoProf"
            />
            <mat-autocomplete #autoProf="matAutocomplete">
              <mat-option *ngFor="let profissao of professions; trackBy: trackByIndex" [value]="profissao.Description">
                &nbsp;&nbsp;{{ profissao.Description }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div *ngIf="isCompany" style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('CAE')">
            <mat-label>{{ 'USERMENU.ACTIVITY' | translate }}</mat-label>
            <input
              type="text"
              matInput
              (ngModelChange)="filteratividade($event)"
              name="CAE"
              required
              autocomplete="off"
              [(ngModel)]="globalService.loggedUserClass.customerClass.CAE"
              (change)="save(true)"
              [matAutocomplete]="autoCae"
            />
            <mat-autocomplete #autoCae="matAutocomplete">
              <mat-option *ngFor="let cae of commonCAE; trackBy: trackByIndex" [value]="cae.ATIVIDADE">
                &nbsp;&nbsp;{{ cae.ATIVIDADE }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div
          *ngIf="globalService.loggedUserClass?.customerClass?.idCustomer && !isCompany"
          style="flex: 1 1 50%; box-sizing: border-box; max-width: 50%"
          class="p-1"
        >
          <button
            type="button"
            class="small-mat-raised-button-default-blue w-100 force-white"
            mat-raised-button
            (click)="addStar()"
          >
            <mat-icon style="color: #dada86">star_border</mat-icon>
            {{ 'USERMENU.INTERESTS' | translate }}
          </button>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('NIB')">
            <mat-label>{{ 'USERMENU.IBAN_NIB' | translate }}</mat-label>
            <span matPrefix style="display: flex; align-items: center">PT50&nbsp;</span>
            <input
              matInput
              type="text"
              name="NIB"
              autocomplete="off"
              maxlength="21"
              inputmode="numeric"
              pattern="[0-9]*"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="globalService.loggedUserClass.customerClass.NIB"
              (ngModelChange)="
                globalService.loggedUserClass?.customerClass &&
                  (globalService.loggedUserClass.customerClass.NIB = $event?.toUpperCase?.() ?? $event)
              "
              (change)="save(true)"
            />
            <button
              type="button"
              matSuffix
              mat-icon-button
              style="font-size: small; margin-right: 0px; padding-right: 0px"
              (click)="findNIB()"
            >
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <mat-form-field class="w-100" appearance="outline" [class.emFalta]="isFieldMissing('Email')">
            <mat-label>{{ 'USERMENU.EMAIL' | translate }}</mat-label>
            <input
              matInput
              type="email"
              name="Email"
              autocomplete="off"
              required
              email
              [(ngModel)]="globalService.loggedUserClass.customerClass.Email"
              (change)="save(true)"
            />
            <button
              type="button"
              matSuffix
              mat-icon-button
              *ngIf="globalService.loggedUserClass?.customerClass?.idCustomer"
              style="font-size: small; margin-right: 0px; padding-right: 0px"
              (click)="findEmails()"
            >
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div style="flex: 1 1 65%; box-sizing: border-box; max-width: 65%" class="p-1">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'USERMENU.OBSERVATIONS' | translate }}</mat-label>
            <textarea
              matInput
              name="Obs"
              autocomplete="off"
              rows="3"
              maxlength="900"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="globalService.loggedUserClass.customerClass.Obs"
              (change)="save(true)"
            ></textarea>
          </mat-form-field>
        </div>

        <div style="flex: 1 1 35%; box-sizing: border-box; max-width: 35%" class="p-1">
          <div style="display: flex; flex-direction: row; flex-wrap: wrap">
            <button
              type="button"
              [class.emFalta]="isFieldMissing('faltaCC')"
              mat-raised-button
              (click)="uploadCartaoCidadao()"
              class="small-mat-raised-button-default w-100"
            >
              <mat-icon>camera_alt</mat-icon>
              {{ 'USERMENU.DOCUMENTS' | translate }}
            </button>
          </div>

          <div *ngIf="!isCompany" style="display: flex; flex-direction: row; flex-wrap: wrap">
            <button
              type="button"
              [class.emFalta]="isFieldMissing('ClientOutros')"
              mat-raised-button
              class="small-mat-raised-button-default w-100"
              (click)="drivecategory()"
            >
              <span style="font-size: 20px; font-weight: bold; padding-bottom: 5px">...</span>
            </button>
          </div>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <mat-checkbox
            style="margin-left: 5px; font-size: 11px"
            name="Newsletter"
            color="primary"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="globalService.loggedUserClass.customerClass.Newsletter"
            (change)="save(true)"
          >
            {{ 'USERMENU.NEWSLETTER_OPTIN' | translate }}
          </mat-checkbox>
        </div>
      </div>

      <div *ngIf="isWhatsAppChannelAvailable" style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <mat-checkbox
            style="margin-left: 5px; font-size: 11px"
            name="AllowWhatsApp"
            color="primary"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="globalService.loggedUserClass.customerClass.AllowWhatsApp"
            (change)="onWhatsAppToggle(); save(true)"
          >
            <span style="display: inline-flex; align-items: center; gap: 5px">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#25D366">
                <path
                  d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
                />
              </svg>
              <span>{{ 'USERMENU.WHATSAPP_OPTIN' | translate }}</span>
            </span>
          </mat-checkbox>

          <!-- Camada 1: Aviso informativo quando WhatsApp está ativo -->
          <div *ngIf="globalService.loggedUserClass?.customerClass?.AllowWhatsApp" class="whatsapp-info-notice">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="#e6a117"
              style="min-width: 14px; margin-top: 1px"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
              />
            </svg>
            <span>{{ 'USERMENU.WHATSAPP_INFO_NOTICE' | translate }}</span>
          </div>

          <!-- Camada 2: Listagem de contas que partilham o mesmo telemóvel -->
          <div
            *ngIf="globalService.loggedUserClass?.customerClass?.AllowWhatsApp && hasActiveSharedWhatsApp"
            class="whatsapp-shared-accounts"
          >
            <div class="whatsapp-shared-accounts__title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="#1b1464"
                style="min-width: 14px"
              >
                <path
                  d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                />
              </svg>
              <span>{{ 'USERMENU.WHATSAPP_SHARED_TITLE' | translate }}</span>
            </div>
            <div class="whatsapp-shared-accounts__list">
              <div *ngFor="let shared of whatsappSharedAccounts" class="whatsapp-shared-accounts__item">
                <span class="whatsapp-shared-accounts__name">{{ shared.Name }}</span>
                <span
                  class="whatsapp-shared-accounts__status"
                  [class.whatsapp-shared-accounts__status--active]="shared.AllowWhatsApp"
                >
                  {{
                    shared.AllowWhatsApp
                      ? ('USERMENU.WHATSAPP_SHARED_ACTIVE' | translate)
                      : ('USERMENU.WHATSAPP_SHARED_INACTIVE' | translate)
                  }}
                </span>
              </div>
            </div>
            <div class="whatsapp-shared-accounts__info">
              {{ 'USERMENU.WHATSAPP_SHARED_REMOVE_INFO' | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- Ligação Segura à Conta Google (OAuth 2.0 / OpenID Connect) -->
      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <div class="google-account-card" [class.google-account-card--linked]="googleStatus.linked">
            <div class="google-account-card__header">
              <div class="google-account-card__title-group">
                <svg class="google-account-card__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                <span class="google-account-card__title">Conta Google</span>
              </div>
              <span class="google-account-card__badge" [class.google-account-card__badge--active]="googleStatus.linked">
                {{ googleStatus.linked ? 'Associada' : 'Não associada' }}
              </span>
            </div>

            <!-- Estado: Não associada -->
            <ng-container *ngIf="!googleStatus.linked">
              <p class="google-account-card__desc">
                Associe a sua conta Google para iniciar sessão com 1 clique neste NIF ({{
                  globalService.loggedUserClass?.NIF
                }}).
              </p>
              <button
                type="button"
                class="google-account-card__btn google-account-card__btn--connect w-100"
                [disabled]="isLoadingGoogle"
                (click)="associarContaGoogle()"
              >
                <mat-icon style="font-size: 15px; width: 15px; height: 15px; margin-right: 6px">link</mat-icon>
                <span>{{ isLoadingGoogle ? 'A associar...' : 'Associar Conta Google' }}</span>
              </button>
            </ng-container>

            <!-- Estado: Associada -->
            <ng-container *ngIf="googleStatus.linked">
              <div
                class="google-account-card__email"
                *ngIf="googleStatus.googleEmail"
                (contextmenu)="onGoogleAccountContextMenu($event, googleAccountMenuTrigger)"
                matTooltip="Clique na foto ou com o botão direito para associar a foto ao perfil"
              >
                <div
                  class="google-account-card__avatar"
                  (click)="$event.stopPropagation(); googleAccountMenuTrigger.openMenu()"
                >
                  <img
                    *ngIf="googleStatus.pictureDataUrl"
                    [src]="googleStatus.pictureDataUrl"
                    alt="Foto Conta Google"
                    class="google-account-card__avatar-img"
                  />
                  <span *ngIf="!googleStatus.pictureDataUrl" class="google-account-card__avatar-initial">
                    {{ googleAccountInitial }}
                  </span>
                  <span class="google-account-card__avatar-badge" title="Associar foto ao perfil">
                    <mat-icon>photo_camera</mat-icon>
                  </span>
                </div>

                <div class="google-account-card__account-info">
                  <div class="google-account-card__email-row">
                    <mat-icon class="google-account-card__verified-icon">verified_user</mat-icon>
                    <span class="google-account-card__email-text">{{ googleStatus.googleEmail }}</span>
                  </div>
                </div>

                <button
                  type="button"
                  class="google-account-card__menu-trigger"
                  [matMenuTriggerFor]="googleAccountContextMenu"
                  #googleAccountMenuTrigger="matMenuTrigger"
                  (click)="$event.stopPropagation()"
                  aria-label="Opções da conta Google associada"
                  matTooltip="Opções de foto e conta"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
              </div>

              <mat-menu #googleAccountContextMenu="matMenu" xPosition="before">
                <button type="button" mat-menu-item [disabled]="isLoadingGoogle" (click)="associarFotoGoogleAoPerfil()">
                  <mat-icon style="color: #1b1464">account_circle</mat-icon>
                  <span>Associar foto ao perfil</span>
                </button>
                <button type="button" mat-menu-item [disabled]="isLoadingGoogle" (click)="sincronizarFotoGoogle(true)">
                  <mat-icon style="color: #2563eb">sync</mat-icon>
                  <span>Atualizar foto da Conta Google</span>
                </button>
                <mat-divider></mat-divider>
                <button
                  type="button"
                  mat-menu-item
                  [disabled]="isLoadingGoogle"
                  (click)="desassociarContaGoogle(false)"
                >
                  <mat-icon style="color: #dc2626">link_off</mat-icon>
                  <span style="color: #dc2626">Desassociar deste NIF</span>
                </button>
              </mat-menu>

              <div class="google-account-card__actions" style="margin-top: 8px; margin-bottom: 6px">
                <button
                  type="button"
                  class="google-account-card__btn google-account-card__btn--unlink w-100"
                  [disabled]="isLoadingGoogle"
                  (click)="desassociarContaGoogle(false)"
                >
                  <mat-icon style="font-size: 15px; width: 15px; height: 15px; margin-right: 6px">link_off</mat-icon>
                  <span>{{ isLoadingGoogle ? 'A desassociar...' : 'Desassociar deste NIF' }}</span>
                </button>
              </div>

              <div class="google-account-card__profiles" *ngIf="googleStatus.linkedProfiles?.length > 1">
                <div class="google-account-card__profiles-title">
                  Outros NIFs onde também associou esta conta Google ({{ googleStatus.linkedProfiles.length }}):
                </div>
                <div class="google-account-card__profile-item" *ngFor="let p of googleStatus.linkedProfiles">
                  <span class="google-account-card__profile-name">{{ p.name }} ({{ p.nif }})</span>
                </div>
                <button
                  type="button"
                  class="google-account-card__btn google-account-card__btn--unlink-all w-100"
                  style="margin-top: 6px"
                  [disabled]="isLoadingGoogle"
                  (click)="desassociarContaGoogle(true)"
                >
                  Desassociar de todos os NIFs
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
        <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <button
            type="button"
            class="small-mat-raised-button-default w-100"
            mat-raised-button
            (click)="openCustomerSchedule()"
          >
            <mat-icon style="font-size: 14px; margin-right: 5px">calendar_today</mat-icon>
            <span>{{ 'USERMENU.PREFERRED_SERVICE' | translate }} </span>
          </button>
        </div>
      </div>

      <mat-divider style="margin: 0px; padding: 0px; line-height: 0.5px"></mat-divider>

      <div
        style="display: flex; flex-direction: row; flex-wrap: wrap; padding-top: 10px"
        *ngIf="availableAreas.length > 1"
      >
        <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%" class="p-1">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'USERMENU.INITIAL_PAGE' | translate }}</mat-label>
            <mat-select
              name="NavigateTo"
              required
              [(ngModel)]="globalService.loggedUserClass.NavigateTo"
              (selectionChange)="saveNavigateTo()"
            >
              <mat-option *ngFor="let area of availableAreas" [value]="area.path">
                {{ area.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <button
        *ngIf="globalService.loggedUserClass?.Admin && globalService.EnableDevelopermode"
        style="color: #920505"
        mat-menu-item
        (click)="configLayout()"
      >
        <mat-icon>settings</mat-icon>
        <span>{{ 'USERMENU.CONFIGURE_CLIENT_LAYOUT' | translate }}</span>
      </button>

      <div style="margin-top: 20px; border-top: 1px solid #efefef; padding-top: 10px">
        <button
          type="button"
          mat-button
          (click)="change()"
          class="w-100"
          style="text-align: left; justify-content: start; color: #444"
        >
          <mat-icon style="font-size: 20px">vpn_key</mat-icon>
          <span style="font-size: 12px; margin-left: 5px">{{ 'USERMENU.CHANGE_PASSWORD' | translate }}</span>
        </button>

        <button
          type="button"
          mat-button
          (click)="logout()"
          class="w-100"
          style="text-align: left; justify-content: start; color: #d32f2f; margin-top: 5px"
        >
          <mat-icon style="font-size: 20px">power_settings_new</mat-icon>
          <span style="font-size: 12px; margin-left: 5px">{{ 'USERMENU.LOGOUT' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- =========================
       TAB GESTOR — Gestores Pessoais
       ========================= -->
  <div *ngIf="menu === 'gestor' && globalService.loggedUserClass">
    <!-- ═══════════════════════════════════════════════
         LISTA DE GESTORES PESSOAIS
         ═══════════════════════════════════════════════ -->
    <div
      *ngIf="!MyManagersAddForm"
      style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 0px; padding-top: 0px; width: 100%"
    >
      <br /><br />
      <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 100%">
        <mat-accordion class="example-headers-align" style="padding: 1px">
          <mat-expansion-panel
            *ngFor="
              let manager of globalService.loggedUserClass?.customerClass?.useMyManagersClass;
              index as indexOfelement;
              trackBy: trackByManager
            "
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ manager?.Name }}
                <div style="flex: 1 1 auto"></div>
                {{ manager.userMyManagersContactsClass?.[0]?.Contact }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <!-- ════════════════════════════════════════
                 MODO VISUALIZAÇÃO (cartão de visita)
                 ════════════════════════════════════════ -->
            <div class="manager-card-body" *ngIf="!showButtonEdit">
              <!-- Avatar com iniciais -->
              <div class="manager-card-body__avatar-row">
                <div class="mediator-card__avatar" style="width: 48px; height: 48px; font-size: 18px">
                  {{ manager.Name ? manager.Name.charAt(0).toUpperCase() : '?' }}
                </div>
              </div>

              <!-- Nome -->
              <div class="manager-card-body__name">{{ manager.Name }}</div>

              <!-- Contactos (telefone) -->
              <div class="manager-card-body__contact-row" *ngFor="let Contacts of manager.userMyManagersContactsClass">
                <svg class="manager-card-body__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                    fill="#4CD6B0"
                  />
                </svg>
                <div class="manager-card-body__contact-info">
                  <span class="manager-card-body__contact-type">{{ Contacts.TypeContact }}</span>
                  <a class="manager-card-body__contact-link" [href]="'tel:' + Contacts.Contact">{{
                    Contacts.Contact
                  }}</a>
                </div>
              </div>

              <!-- Emails -->
              <div class="manager-card-body__contact-row" *ngFor="let Emails of manager.userMyManagersEmailsClass">
                <svg class="manager-card-body__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                    fill="#4CD6B0"
                  />
                </svg>
                <div class="manager-card-body__contact-info">
                  <span class="manager-card-body__contact-type">{{ Emails.TypeContact }}</span>
                  <a class="manager-card-body__contact-link" [href]="'mailto:' + Emails.Contact">{{
                    Emails.Contact
                  }}</a>
                </div>
              </div>

              <!-- Serviços e Acessibilidades (texto) -->
              <div class="manager-card-body__services" *ngIf="manager.Info">
                <div class="manager-card-body__services-title">{{ 'USERMENU.SERVICES_ACCESSIBILITY' | translate }}</div>
                <div class="manager-card-body__services-text">{{ manager.Info }}</div>
              </div>

              <!-- Botões de acção -->
              <div class="manager-card-body__actions">
                <button
                  type="button"
                  mat-stroked-button
                  class="manager-card-body__btn"
                  (click)="showButtonEdit = true; editManager(manager)"
                >
                  {{ 'USERMENU.EDIT' | translate }}
                </button>

                <button
                  type="button"
                  mat-stroked-button
                  class="manager-card-body__btn"
                  (click)="shareMediatorContact()"
                >
                  {{ 'USERMENU.SHARE' | translate }}
                </button>

                <button
                  type="button"
                  mat-stroked-button
                  class="manager-card-body__btn manager-card-body__btn--delete"
                  (click)="deleteManager(indexOfelement)"
                >
                  {{ 'USERMENU.DELETE' | translate }}
                </button>
              </div>
            </div>

            <!-- ════════════════════════════════════════
                 MODO EDIÇÃO (formulário)
                 ════════════════════════════════════════ -->
            <div class="manager-card-body" *ngIf="showButtonEdit">
              <!-- Avatar com iniciais -->
              <div class="manager-card-body__avatar-row">
                <div class="mediator-card__avatar" style="width: 48px; height: 48px; font-size: 18px">
                  {{ manager.Name ? manager.Name.charAt(0).toUpperCase() : '?' }}
                </div>
              </div>

              <!-- Nome -->
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>{{ 'USERMENU.NAME' | translate }}</mat-label>
                <input
                  matInput
                  [attr.name]="'manager_name_' + indexOfelement"
                  autocomplete="off"
                  required
                  [(ngModel)]="manager.Name"
                />
              </mat-form-field>

              <!-- CONTACTOS -->
              <div
                class="manager-card-body__field-row"
                *ngFor="
                  let Contacts of manager.userMyManagersContactsClass;
                  index as indexContact;
                  trackBy: trackByIndex
                "
              >
                <svg class="manager-card-body__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                    fill="#4CD6B0"
                  />
                </svg>
                <mat-form-field class="w-100" appearance="outline">
                  <mat-select
                    class="w-50"
                    style="margin: 0; padding: 0; font-size: 11px; border: none; line-height: 12px"
                    [attr.name]="'manager_contact_type_' + indexOfelement + '_' + indexContact"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="Contacts.TypeContact"
                  >
                    <mat-option value="Telemóvel">{{ 'USERMENU.PHONE_TYPE.MOBILE' | translate }}</mat-option>
                    <mat-option value="Emprego">{{ 'USERMENU.PHONE_TYPE.WORK' | translate }}</mat-option>
                    <mat-option value="Domicílio">{{ 'USERMENU.PHONE_TYPE.HOME' | translate }}</mat-option>
                    <mat-option value="Principal">{{ 'USERMENU.PHONE_TYPE.MAIN' | translate }}</mat-option>
                    <mat-option value="Outro">{{ 'USERMENU.PHONE_TYPE.OTHER' | translate }}</mat-option>
                  </mat-select>
                  <input
                    style="padding-top: 10px"
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    maxlength="9"
                    matInput
                    [attr.name]="'manager_contact_' + indexOfelement + '_' + indexContact"
                    autocomplete="off"
                    required
                    [(ngModel)]="Contacts.Contact"
                    (keypress)="$event.charCode >= 48 && $event.charCode <= 57 ? true : $event.preventDefault()"
                    (paste)="$event.preventDefault()"
                    (click)="$event.stopPropagation()"
                  />
                  <mat-icon
                    style="cursor: pointer; font-size: 22px; padding-right: 5px; padding-top: 5px"
                    matSuffix
                    (click)="deleteuserMyManagersContactsClass(indexOfelement, indexContact)"
                  >
                    close
                  </mat-icon>
                </mat-form-field>
              </div>

              <button
                type="button"
                style="margin-top: -10px; margin-bottom: 8px"
                mat-button
                class="w-100"
                (click)="addEmptyContact(indexOfelement)"
              >
                <mat-icon style="color: #4cd6b0; font-size: 18px">add</mat-icon>
                <span style="color: #4cd6b0; font-size: 11px">{{ 'USERMENU.ADD_PHONE' | translate }}</span>
              </button>

              <!-- EMAILS -->
              <div
                class="manager-card-body__field-row"
                *ngFor="let Emails of manager.userMyManagersEmailsClass; index as indexEmail; trackBy: trackByIndex"
              >
                <svg class="manager-card-body__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                    fill="#4CD6B0"
                  />
                </svg>
                <mat-form-field class="w-100" appearance="outline">
                  <mat-select
                    class="w-50"
                    style="margin: 0; padding: 0; font-size: 11px; border: none; line-height: 12px"
                    [attr.name]="'manager_email_type_' + indexOfelement + '_' + indexEmail"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="Emails.TypeContact"
                  >
                    <mat-option value="Pessoal">{{ 'USERMENU.EMAIL_TYPE.PERSONAL' | translate }}</mat-option>
                    <mat-option value="Emprego">{{ 'USERMENU.EMAIL_TYPE.WORK' | translate }}</mat-option>
                    <mat-option value="Outro">{{ 'USERMENU.EMAIL_TYPE.OTHER' | translate }}</mat-option>
                  </mat-select>
                  <input
                    style="padding-top: 10px"
                    matInput
                    type="email"
                    [attr.name]="'manager_email_' + indexOfelement + '_' + indexEmail"
                    autocomplete="off"
                    required
                    [(ngModel)]="Emails.Contact"
                    (click)="$event.stopPropagation()"
                  />
                  <mat-icon
                    matSuffix
                    style="cursor: pointer; font-size: 22px; padding-right: 5px; padding-top: 5px"
                    (click)="deleteuseruserMyManagersEmailsClass(indexOfelement, indexEmail)"
                  >
                    close
                  </mat-icon>
                </mat-form-field>
              </div>

              <button
                type="button"
                style="margin-top: -10px; margin-bottom: 8px"
                mat-button
                class="w-100"
                (click)="addEmptyEmail(indexOfelement)"
              >
                <mat-icon style="color: #4cd6b0; font-size: 18px">add</mat-icon>
                <span style="color: #4cd6b0; font-size: 11px">{{ 'USERMENU.ADD_EMAIL' | translate }}</span>
              </button>

              <!-- Serviços e Acessibilidades -->
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>{{ 'USERMENU.SERVICES_ACCESSIBILITY' | translate }}</mat-label>
                <textarea
                  class="manager-card-body__textarea-no-scroll"
                  matInput
                  [attr.name]="'manager_info_' + indexOfelement"
                  autocomplete="off"
                  rows="3"
                  maxlength="900"
                  [(ngModel)]="manager.Info"
                ></textarea>
              </mat-form-field>

              <!-- Botões de acção (edição) -->
              <div class="manager-card-body__actions">
                <button
                  type="button"
                  mat-stroked-button
                  class="manager-card-body__btn"
                  (click)="showButtonEdit = false; cancelManager(manager)"
                >
                  {{ 'USERMENU.CANCEL' | translate }}
                </button>

                <button
                  type="button"
                  mat-flat-button
                  class="manager-card-body__btn manager-card-body__btn--save"
                  (click)="save(false); showButtonEdit = false"
                >
                  {{ 'USERMENU.SAVE' | translate }}
                </button>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>

    <!-- FORM ADD MANAGER (redesenhado) -->
    <div *ngIf="MyManagersAddForm" class="manager-add-form">
      <!-- Título -->
      <div class="manager-add-form__title">
        {{ 'USERMENU.ADD' | translate }} {{ 'USERMENU.TAB_MANAGERS' | translate | lowercase }}
      </div>

      <!-- Avatar placeholder -->
      <div class="manager-add-form__avatar-wrapper">
        <div class="manager-add-form__avatar">
          {{ ManagersClass.Name ? ManagersClass.Name.charAt(0).toUpperCase() : '?' }}
        </div>
      </div>

      <!-- Nome -->
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{ 'USERMENU.NAME' | translate }}</mat-label>
        <input matInput name="NewManagerName" autocomplete="off" required [(ngModel)]="ManagersClass.Name" />
      </mat-form-field>

      <!-- Telefone -->
      <div class="manager-add-form__field-row">
        <svg class="manager-add-form__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
            fill="#b8b8b8"
          />
        </svg>
        <mat-form-field class="w-100" appearance="outline">
          <mat-select
            class="w-50"
            style="margin: 0; padding: 0; font-size: 11px; border: none"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="telMyManagersContactsClass.TypeContact"
          >
            <mat-option value="Telemóvel">{{ 'USERMENU.PHONE_TYPE.MOBILE' | translate }}</mat-option>
            <mat-option value="Emprego">{{ 'USERMENU.PHONE_TYPE.WORK' | translate }}</mat-option>
            <mat-option value="Domicílio">{{ 'USERMENU.PHONE_TYPE.HOME' | translate }}</mat-option>
            <mat-option value="Principal">{{ 'USERMENU.PHONE_TYPE.MAIN' | translate }}</mat-option>
            <mat-option value="Outro">{{ 'USERMENU.PHONE_TYPE.OTHER' | translate }}</mat-option>
          </mat-select>
          <input
            style="padding-top: 10px"
            type="tel"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="9"
            matInput
            name="NewManagerPhone"
            autocomplete="off"
            required
            (keypress)="$event.charCode >= 48 && $event.charCode <= 57 ? true : $event.preventDefault()"
            (paste)="$event.preventDefault()"
            (click)="$event.stopPropagation()"
            [(ngModel)]="telMyManagersContactsClass.Contact"
          />
        </mat-form-field>
      </div>

      <!-- Email -->
      <div class="manager-add-form__field-row">
        <svg class="manager-add-form__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
            fill="#b8b8b8"
          />
        </svg>
        <mat-form-field class="w-100" appearance="outline">
          <mat-select
            class="w-50"
            style="margin: 0; padding: 0; font-size: 11px; border: none; line-height: 12px"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="emailUserMyManagersContactsClass.TypeContact"
          >
            <mat-option value="Pessoal">{{ 'USERMENU.EMAIL_TYPE.PERSONAL' | translate }}</mat-option>
            <mat-option value="Emprego">{{ 'USERMENU.EMAIL_TYPE.WORK' | translate }}</mat-option>
            <mat-option value="Outro">{{ 'USERMENU.EMAIL_TYPE.OTHER' | translate }}</mat-option>
          </mat-select>
          <input
            style="padding-top: 10px"
            matInput
            name="NewManagerEmail"
            type="email"
            autocomplete="off"
            [ngModelOptions]="{ standalone: true }"
            (click)="$event.stopPropagation()"
            [(ngModel)]="emailUserMyManagersContactsClass.Contact"
          />
        </mat-form-field>
      </div>

      <!-- Informações -->
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{ 'USERMENU.INFO' | translate }}</mat-label>
        <textarea
          matInput
          name="NewManagerInfo"
          autocomplete="off"
          rows="3"
          maxlength="900"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="ManagersClass.Info"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="manager-add-form__actions">
      <button
        *ngIf="showButtonAdd"
        mat-button
        color="primary"
        (click)="addManager()"
        type="button"
        class="manager-add-form__btn-add"
      >
        <span style="display: inline-flex; align-items: center; gap: 6px">
          <mat-icon>add</mat-icon>
          <span>{{ 'USERMENU.ADD' | translate }}</span>
        </span>
      </button>

      <button
        *ngIf="showButtonSave"
        mat-stroked-button
        (click)="cancelanager()"
        type="button"
        class="manager-add-form__btn-cancel"
      >
        {{ 'USERMENU.CANCEL' | translate }}
      </button>

      <button
        *ngIf="showButtonSave"
        mat-flat-button
        color="primary"
        (click)="saveanager(true)"
        type="button"
        class="manager-add-form__btn-save"
      >
        {{ 'USERMENU.SAVE' | translate }}
      </button>
    </div>
  </div>

  <div *ngIf="showProgress" style="display: flex; justify-content: center; align-items: center; max-width: 300px">
    <app-loading [hide]="false"></app-loading>
  </div>
</form>
